import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const CountryQuery = gql`
  query country($code: String!) {
    country(where: { code: $code }) {
      id
      title
      name
      details
      VATrate
      currency
      language
      code
      flag
      weightUnit
      parentCountryId
      states {
        id
        name
        title
        vatRate
      }
      business {
        id
        name
        company
        street
        houseNumber
        addressLine1
        addressLine2
        city
        zip
        countyState
        country
        vatNumber
        registrationNumber
        phone
        email
        emailForNotification
        web
        bankName
        iban
        swift
      }
    }
    businessList {
      id
      default
      company
      addressLine1
      addressLine2
      city
      zip
      countyState
      country
      vatNumber
      registrationNumber
      phone
      email
      emailForNotification
      web
    }
  }
`;

interface IInputProps {
  children?: any;
  code: string;
}

interface IResponse {
  data: any;
}

class GetCountryQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
  public render() {
    const { country }: any = this.props;
    return this.props.children({ country });
  }
}

export default compose(
  graphql<IInputProps, Response>(CountryQuery, {
    name: 'country',
    options: props => ({ variables: { code: props.code } })
  })
)(GetCountryQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Countries/Country.tsx